import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

import { type PropType } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'image-arrow',
  props: {
    mode: {
        type: String as PropType<"next" | "prev">,
        required: true,
    },
},
  emits: ["click"],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    tabindex: "0",
    class: _normalizeClass(['image-arrow', 'image-arrow--' + __props.mode]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    type: "button"
  }, [
    (__props.mode === 'next')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708",
            stroke: "currentColor",
            "stroke-width": "1"
          }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    (__props.mode === 'prev')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0",
            stroke: "currentColor",
            "stroke-width": "1"
          }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}
}

})